import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const SelfStatsFlareUp = ({ flareUpStats, startDate, endDate }) => {
  const { t } = useTranslation();
  const getDatesInRange = (start, end) => {
    const dates = [];
    let cur = new Date(start);
    while (cur <= end) {
      dates.push(cur.toISOString().split("T")[0]);
      cur.setDate(cur.getDate() + 1);
    }
    return dates;
  };

  const categories = useMemo(() => {
    return getDatesInRange(startDate, endDate).map((d) => {
      const dt = new Date(d);
      return Highcharts.dateFormat("%b %e", dt);
    });
  }, [startDate, endDate]);

  const seriesData = useMemo(() => {
    const grouped = {};
    flareUpStats.filter((e) => e.createdTime).forEach((e) => {
      const date = new Date(e.createdTime).toISOString().split("T")[0];
      const intensity = e["1"] && Array.isArray(e["1"]) ? parseInt(e["1"][0]) : 0;
      if (!grouped[date]) grouped[date] = { total: 0, count: 0 };
      grouped[date].total += intensity;
      grouped[date].count++;
    });
    return getDatesInRange(startDate, endDate).map((date) => {
      const dt = new Date(date);
      const label = Highcharts.dateFormat("%b %e", dt);
      const idx = categories.indexOf(label);
      const d = grouped[date];
      return d ? parseFloat((d.total / d.count).toFixed(2)) : 0;
    });
  }, [flareUpStats, categories, startDate, endDate]);

  const options = {
    chart: { type: "column", height: 280, margin: [10, 0, 50, 50], backgroundColor: "rgba(0,0,0,0)" },
    title: { text: "" },
    credits: { enabled: false },
    xAxis: { categories, title: { text: t("selfStats.daysAxis") }, lineWidth: 0 },
    yAxis: { title: { text: t("selfStats.intensityAxis") }, gridLineDashStyle: "dot", gridLineColor: "#646464", tickPositions: [0,1,2,3,4,5,6,7,8,9,10] },
    plotOptions: { column: { pointWidth: 10, borderRadius: 10, borderWidth: 0 } },
    series: [{ name: "(Level)", showInLegend: false, data: seriesData }],
    legend: { enabled: false },
  };

  return (
    <div className="selfstats-box">
      <h2 className="selfstats-title">{t("selfStats.flareUpTitle")}</h2>
      <p className="selfstats-subtitle">{t("selfStats.flareUpSubtitle")}</p>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

SelfStatsFlareUp.defaultProps = { flareUpStats: [], startDate: new Date(), endDate: new Date() };

export default SelfStatsFlareUp;
